export default __webpack_public_path__ + "static/media/facialrecognition.57ceac7c.jpg";